import { render, staticRenderFns } from "./CreateOtherProfilePage.vue?vue&type=template&id=367a60e6&scoped=true"
import script from "./CreateOtherProfilePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateOtherProfilePage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateOtherProfilePage.vue?vue&type=style&index=0&id=367a60e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367a60e6",
  null
  
)

export default component.exports